<div class="filter-group" data-group-visibility-id="showMyArmourFilters">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showMyArmourFilters" (click)="filter.groupVisibility.showMyArmourFilters = !filter.groupVisibility.showMyArmourFilters; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Favourite Armour" [activeRules]="activeSpecialRules.armourExceptions">
          Select the armour you are looking for for your character(s), optionally set minimal conditions, and configure which Variants (like Crafting Bases{{ poe2 ? ' or Tiered Unidentified versions' : '' }}) you're interested in and how they should be highlighted using the <span class="icon icon-equalizer"></span> button.

          <br /><br /><app-content cid="gear-tiers" contentType="tip" [conditions]="{extraInfo: true, poe2: poe2}" style="display: inline-block;"></app-content>

          <br/><br/>Rules with a <span class="equipment-filter-from-preset-example">gold line</span> to the left were automatically generated from your Class or Progress Preset, and might get changed along with presets.
        </span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showMyArmourFilters) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showMyArmourFilters">

      @for (armour of filter.armourFilters; track $index) {
        <app-armour-filter
          [armour]="armour"
          [index]="$index"
          (remove)="removeArmourType($event)">
        </app-armour-filter>
      }

      <div class="filter filter-padded">
        <button type="button" class="btn clear-btn" style="width: 100%;" (click)="addArmourType()">
          Add Armour Type
        </button>
      </div>
    </div>
    <div class="clear"></div>
  }
</div>
